import mask from 'jquery-mask-plugin';
(function () {

  "use strict";

  //template base do chat
  function chatTemplate(aiOrPerson) {
    return (
      `
    <div class="ai-person-container">
     <span class="${aiOrPerson.class}-date">${aiOrPerson.date}</span><br>
		<div class="${aiOrPerson.class}-icon"></div>
		<div class="${aiOrPerson.class}">
		  <p>${aiOrPerson.text}</p>
		</div>
	  </div>
	`
    );
  }

  //listagem das perguntas fixas
  const responses = [
    "Olá! Qual é o seu nome completo?",
    "Certo, [Nome]. Qual o seu telefone com DDD?",
    "Ok. Agora preciso do seu e-mail.",
    "Qual é o nome da sua empresa?",
    "Qual o tipo do acionamento?<br> Digite 1: para normal <br> Digite 2: para inverso",
    "Obrigado. Para lhe indicar a melhor opção de pistão para seu móvel. Qual a LARGURA (em centímetros) da porta basculante do móvel onde irá instalar o pistão para móveis?",
    "Certo. E qual a ALTURA (em centímetros) da porta basculante do móvel onde irá instalar o pistão para móveis?",
    "Ok, Por fim, qual a ESPESSURA (em centímetros) da porta basculante do móvel onde irá instalar o pistão para móveis?",
    "Certo. Segue o resultado de acordo com as medidas informadas:",
  ];

  var product_up = [
    { title: "06023.2040.05", force: 40, base: 2 },
    { title: "06023.2050.05", force: 50, base: 2 },
    { title: "06023.2060.05", force: 60, base: 2 },
    { title: "06023.2080.05", force: 80, base: 2 },
    { title: "06023.2100.05", force: 100, base: 2 },
    { title: "06023.2120.05", force: 120, base: 2 },
    { title: "06023.2150.05", force: 150, base: 2 },

  ];

  var product_up_mini = [
    { title: "06023.4060.05", force: 60, base: 2 },
    { title: "06023.4080.05", force: 80, base: 2 },
  ];

  var product_up_soft = [
    { title: "06023.3060.05", force: 60, base: 2 },
    { title: "06023.3080.05", force: 80, base: 2 },
    { title: "06023.3100.05", force: 100, base: 2 }
  ];

  var product_down = [
    { title: "06023.2006.05", force: 60, base: 2 },
    { title: "06023.2008.05", force: 80, base: 2 },
    { title: "06023.2010.05", force: 100, base: 2 },
    { title: "06023.2012.05", force: 120, base: 2 },
  ];

  var product_down_mini = [
    { title: "06023.4006.05", force: 60, base: 2 }
  ];

  //variável usada para controlar qual pergunta mostra
  var num = 1;
  var caract = new RegExp(/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/);
  var pesoporta, baricentrocm, baricentromm, pistaoMini, pistaoNormal, pistaoIndicadoMini, pistaoIndicadoNormal;

  const submit = document.querySelector(".chat-submit");
  const chatBox = document.querySelector(".chat-box");
  const chatInput = document.querySelector(".chat-input");

  //monta o chat inicial
  const date = new Date()
  const timestamp = date.toLocaleTimeString()
  const newChatDiv = chatTemplate({
    class: "ai",
    text: "Olá! Qual é o seu nome completo?",
    date: timestamp
  });
  chatBox.innerHTML += newChatDiv;

  var nome, telefone, email, empresa, acionamento, altura, alturam, largura, larguram, espessura, espessuram, html;
  var products = [];
  var products_ajax, message_ajax;


  $('.refazer').click(function (e) {
    products = [];
    $('.refazer').removeClass('d-block').addClass('d-none');
    num = 4;
    appendChatBox(false);
  });


  //controla o envio do chat no clique de submit
  submit.addEventListener("click", function (e) {
    var email = $('.chat-input').val();

    if (chatInput.name == 'email' && caract.test(email) == false) {
    } else if ((chatInput.name == 'acionamento') && (chatInput.value < 1)) {
    } else if ((chatInput.name == 'acionamento') && (chatInput.value > 2)) {

    } else {
      appendChatBox(true);
    }
  });

  //controla o envio do chat ao dar enter
  document.addEventListener("keypress", function (e) {
    var email = $('.chat-input').val();
    if (chatInput.name == 'email' && caract.test(email) == false) {
    } else if ((chatInput.name == 'acionamento') && (chatInput.value < 1)) {
    } else if ((chatInput.name == 'acionamento') && (chatInput.value > 2)) {

    } else if (e.keyCode == "13") {
      appendChatBox(true);
    }
  });

  //monta o chat de acordo com a class de pessoa ou "robot"
  function appendChatBox(fromPerson) {
    const date = new Date()
    if (!fromPerson) {
      date.setSeconds(date.getSeconds() + 2)
    }
    if (fromPerson && !chatInput.value.trim()) {
      return;
    }
    const timestamp = date.toLocaleTimeString()
    const newChatDiv = chatTemplate({
      class: fromPerson ? "person" : "ai",
      text: fromPerson ? chatInput.value.trim() : aiResponse(),
      date: timestamp
    });
    if (!fromPerson) {
      // make it so it only responds once to multiple fast sentences
      setTimeout(function () {
        chatBox.innerHTML += newChatDiv;
        chatBox.scrollTop = chatBox.scrollHeight;
      }, 2000)
    } else {
      chatBox.innerHTML += newChatDiv;
      chatBox.scrollTop = chatBox.scrollHeight;

      if (chatInput.name == 'nome') {
        nome = chatInput.value;
      } else if (chatInput.name == 'phone') {
        telefone = chatInput.value;
      } else if (chatInput.name == 'email') {
        email = chatInput.value;
      } else if (chatInput.name == 'empresa') {
        empresa = chatInput.value;
      } else if (chatInput.name == 'acionamento') {
        acionamento = chatInput.value;
      } else if (chatInput.name == 'altura') {
        altura = chatInput.value;
        altura = altura.replace(',', '.').replace(/[^0-9.]/g, '');
        alturam = altura / 100;
      } else if (chatInput.name == 'largura') {
        largura = chatInput.value;
        largura = largura.replace(',', '.').replace(/[^0-9.]/g, '');
        larguram = largura / 100;
      } else if (chatInput.name == 'espessura') {
        espessura = chatInput.value;
        espessura = espessura.replace(',', '.').replace(/[^0-9.]/g, '');
        espessuram = espessura / 100;
      }

    }
    if (num == 9) {
      appendChatBox(false);
    }
    if (num == 10) {
      setTimeout(function () {
        $('.refazer').removeClass('d-none').addClass('d-block');
        chatBox.scrollTop = chatBox.scrollHeight;
      }, 2500)
    }
    if (fromPerson) {
      appendChatBox(false);
    }
  }

  //controla as respostas do "robot"
  function aiResponse() {

    if (num == 1) {
      const response = 'Certo, ' + chatInput.value.trim() + '. Qual o seu telefone com DDD?';
      chatInput.value = "";
      chatInput.type = 'tel';
      chatInput.name = 'phone';
      $(".chat-input").mask("(00) 00000-0000");

      ++num;
      return response;
    }
    else if (num == 2) {
      const response = responses[num];
      chatInput.value = "";
      chatInput.type = 'email';
      chatInput.name = 'email';
      $(".chat-input").unmask();

      ++num;
      return response;
    }
    else if (num == 3) {
      const response = responses[num];
      chatInput.value = "";
      chatInput.type = 'text';
      chatInput.name = 'empresa';
      $(".chat-input").unmask();

      ++num;
      return response;
    }
    else if (num == 4) {
      const response = responses[num];
      chatInput.value = "";
      chatInput.type = 'number';
      chatInput.name = 'acionamento';
      chatInput.min = '1';
      chatInput.max = '2';
      $(".chat-input").unmask();

      ++num;
      return response;
    }
    else if (num == 5) {
      const response = responses[num];
      chatInput.value = "";
      chatInput.type = 'text';
      chatInput.name = 'largura';
      chatInput.min = null;
      chatInput.max = null;
      $(".chat-input").unmask();

      ++num;
      return response;
    }

    else if (num == 6) {
      const response = responses[num];
      chatInput.value = "";
      chatInput.type = 'text';
      chatInput.name = 'altura';
      $(".chat-input").unmask();

      ++num;
      return response;
    }

    else if (num == 7) {
      const response = responses[num];
      chatInput.value = "";
      chatInput.type = 'text';
      chatInput.name = 'espessura';

      ++num;
      return response;
    }
    else if (num == 8) {
      if (largura >= 80) {
        response = 'Certo. Para portas com largura maior ou igual a 80cm, recomenda-se o uso de <b>2 pistões</b>. Segue o resultado de acordo com as medidas informadas: ';
      } else {
        response = responses[num];
      }
      chatInput.value = "";
      chatInput.type = 'text';
      chatInput.name = 'info';


      ++num;
      return response;
    }
    else if (num == 9) {

      pesoporta = larguram * alturam * espessuram * 750;
      baricentrocm = altura / 2;
      baricentromm = baricentrocm * 10;
      pistaoMini = pesoporta * (baricentromm / 59) * 1.25;
      pistaoNormal = pesoporta * (baricentromm / 91) * 1.25;

      if (largura >= 80) {
        pistaoIndicadoMini = (pistaoMini * 10) / 2;
        pistaoIndicadoNormal = (pistaoNormal * 10) / 2;
      } else {
        pistaoIndicadoMini = pistaoMini;
        pistaoIndicadoNormal = pistaoNormal;
      }

      pistaoIndicadoMini = pistaoIndicadoMini.toFixed(2);
      pistaoIndicadoNormal = pistaoIndicadoNormal.toFixed(2);

      if (acionamento == 1) {
        $.each(product_up_mini, function (index, product) {
          if ((pistaoIndicadoMini >= 35 && pistaoIndicadoMini <= 45) && (product.force == 40)) {
            products.push(product)
          } else if ((pistaoIndicadoMini >= 45.01 && pistaoIndicadoMini <= 55) && (product.force == 50)) {
            products.push(product)
          } else if ((pistaoIndicadoMini >= 55.01 && pistaoIndicadoMini <= 70) && (product.force == 60)) {
            products.push(product)
          } else if ((pistaoIndicadoMini >= 70.01 && pistaoIndicadoMini <= 85) && (product.force == 80)) {
            products.push(product)
          } else if ((pistaoIndicadoMini >= 85.01 && pistaoIndicadoMini <= 105) && (product.force == 100)) {
            products.push(product)
          } else if ((pistaoIndicadoMini >= 105.01 && pistaoIndicadoMini <= 125) && (product.force == 120)) {
            products.push(product)
          } else if ((pistaoIndicadoMini >= 125.01 && pistaoIndicadoMini <= 155) && (product.force == 150)) {
            products.push(product)
          }
        });

        $.each(product_up, function (index, product) {
          if ((pistaoIndicadoNormal >= 35 && pistaoIndicadoNormal <= 45) && (product.force == 40)) {
            products.push(product)
          } else if ((pistaoIndicadoNormal >= 45.01 && pistaoIndicadoNormal <= 55) && (product.force == 50)) {
            products.push(product)
          } else if ((pistaoIndicadoNormal >= 55.01 && pistaoIndicadoNormal <= 70) && (product.force == 60)) {
            products.push(product)
          } else if ((pistaoIndicadoNormal >= 70.01 && pistaoIndicadoNormal <= 85) && (product.force == 80)) {
            products.push(product)
          } else if ((pistaoIndicadoNormal >= 85.01 && pistaoIndicadoNormal <= 105) && (product.force == 100)) {
            products.push(product)
          } else if ((pistaoIndicadoNormal >= 105.01 && pistaoIndicadoNormal <= 125) && (product.force == 120)) {
            products.push(product)
          } else if ((pistaoIndicadoNormal >= 125.01 && pistaoIndicadoNormal <= 155) && (product.force == 150)) {
            products.push(product)
          }
        });

        $.each(product_up_soft, function (index, product) {
          if ((pistaoIndicadoNormal >= 35 && pistaoIndicadoNormal <= 45) && (product.force == 40)) {
            products.push(product)
          } else if ((pistaoIndicadoNormal >= 45.01 && pistaoIndicadoNormal <= 55) && (product.force == 50)) {
            products.push(product)
          } else if ((pistaoIndicadoNormal >= 55.01 && pistaoIndicadoNormal <= 70) && (product.force == 60)) {
            products.push(product)
          } else if ((pistaoIndicadoNormal >= 70.01 && pistaoIndicadoNormal <= 85) && (product.force == 80)) {
            products.push(product)
          } else if ((pistaoIndicadoNormal >= 85.01 && pistaoIndicadoNormal <= 105) && (product.force == 100)) {
            products.push(product)
          } else if ((pistaoIndicadoNormal >= 105.01 && pistaoIndicadoNormal <= 125) && (product.force == 120)) {
            products.push(product)
          } else if ((pistaoIndicadoNormal >= 125.01 && pistaoIndicadoNormal <= 155) && (product.force == 150)) {
            products.push(product)
          }
        });
      } else {
        $.each(product_down_mini, function (index, product) {
          if ((pistaoIndicadoMini >= 35 && pistaoIndicadoMini <= 45) && (product.force == 40)) {
            products.push(product)
          } else if ((pistaoIndicadoMini >= 45.01 && pistaoIndicadoMini <= 55) && (product.force == 50)) {
            products.push(product)
          } else if ((pistaoIndicadoMini >= 55.01 && pistaoIndicadoMini <= 70) && (product.force == 60)) {
            products.push(product)
          } else if ((pistaoIndicadoMini >= 70.01 && pistaoIndicadoMini <= 85) && (product.force == 80)) {
            products.push(product)
          } else if ((pistaoIndicadoMini >= 85.01 && pistaoIndicadoMini <= 105) && (product.force == 100)) {
            products.push(product)
          } else if ((pistaoIndicadoMini >= 105.01 && pistaoIndicadoMini <= 125) && (product.force == 120)) {
            products.push(product)
          } else if ((pistaoIndicadoMini >= 125.01 && pistaoIndicadoMini <= 155) && (product.force == 150)) {
            products.push(product)
          }
        });

        $.each(product_down, function (index, product) {
          if ((pistaoIndicadoNormal >= 35 && pistaoIndicadoNormal <= 45) && (product.force == 40)) {
            products.push(product)
          } else if ((pistaoIndicadoNormal >= 45.01 && pistaoIndicadoNormal <= 55) && (product.force == 50)) {
            products.push(product)
          } else if ((pistaoIndicadoNormal >= 55.01 && pistaoIndicadoNormal <= 70) && (product.force == 60)) {
            products.push(product)
          } else if ((pistaoIndicadoNormal >= 70.01 && pistaoIndicadoNormal <= 85) && (product.force == 80)) {
            products.push(product)
          } else if ((pistaoIndicadoNormal >= 85.01 && pistaoIndicadoNormal <= 105) && (product.force == 100)) {
            products.push(product)
          } else if ((pistaoIndicadoNormal >= 105.01 && pistaoIndicadoNormal <= 125) && (product.force == 120)) {
            products.push(product)
          } else if ((pistaoIndicadoNormal >= 125.01 && pistaoIndicadoNormal <= 155) && (product.force == 150)) {
            products.push(product)
          }
        });
      }
      products_ajax = JSON.stringify(products);
      message_ajax = 'Acionamento: ' + acionamento + ', Largura: ' + largura + ', Altura: ' + altura + ', Espessura: ' + espessura;
      var response = '';

      var match = document.cookie.match(new RegExp('(^| )' + '__trf.src' + '=([^;]+)'));
      var traffic_source = '';
      if (match) {
        traffic_source = match[2];
      }

      $.ajax({
        url: $('#calculadora').attr('data-url'),
        type: 'POST',
        dataType: 'json',
        data: { 'products': products_ajax, 'nome': nome, 'telefone': telefone, 'email': email, 'empresa': empresa, 'message': message_ajax, 'altura': altura, 'largura': largura, 'espessura': espessura, 'acionamento': acionamento, 'traffic_source': traffic_source, '_token': $('meta[name="csrf-token"]').attr('content') },
        async: false,
        error: function () {
          response = jsi18n.ajax_error_message;
          /*Swal.fire({
            title: jsi18n.ajax_error_title,
            text: jsi18n.ajax_error_message,
            imageUrl: site_url + 'site/img/iconError.png',
            imageWidth: 76,
            imageHeight: 76
          });*/
        },
        success: function (json) {
          if (json.status) {
            response = json.content;
          } else {
            /*Swal.fire({
              title: json.title,
              text: json.message,
              imageUrl: site_url + 'site/img/iconError.png',
              imageWidth: 76,
              imageHeight: 76
            });*/
            $('.refazer').removeClass('d-none').addClass('d-block');
            $('.falar').removeClass('d-none').addClass('d-block');
            response = json.message;
          }
        }
      });
      ++num;
      return response;
    }
  }

  $('.falar').click(function (e) {
    $('.modalLoader').show();
    $.ajax({
      url: $('#calculadora').attr('data-url'),
      type: 'POST',
      dataType: 'json',
      data: { 'send': true, 'products': products_ajax, 'nome': nome, 'telefone': telefone, 'email': email, 'empresa': empresa, 'message': message_ajax, 'altura': altura, 'largura': largura, 'espessura': espessura, 'acionamento': acionamento, '_token': $('meta[name="csrf-token"]').attr('content') },
      async: false,
      error: function () {
        $('.modalLoader').hide();
        Swal.fire({
          title: jsi18n.ajax_error_title,
          text: jsi18n.ajax_error_message,
          imageUrl: site_url + 'site/img/iconError.png',
          imageWidth: 76,
          imageHeight: 76
        });
      },
      success: function (json) {
        $('.modalLoader').hide();
        if (json.status) {
          Swal.fire({
            title: (json.title) ? json.title : jsi18n.ajax_success_title,
            html: json.message,
            imageUrl: site_url + 'site/img/iconSuccess.png',
            imageWidth: 76,
            imageHeight: 76
          });
        } else {
          Swal.fire({
            title: json.title,
            text: json.message,
            imageUrl: site_url + 'site/img/iconError.png',
            imageWidth: 76,
            imageHeight: 76
          });
        }
      }
    });
  });
}())